exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-activity-design-inline .activity-inline-display.activity-inline-display--navi .fts-label-group:hover{transform:scale(1.075);transition:transform .3s ease-in-out;cursor:pointer}", ""]);

// exports
